import { NoDataAvailableDiv } from "components/NoDataAvailableDiv";
import PanelSegment from "components/panels/PanelSegment/PanelSegment";
import SectionPanel from "components/panels/SectionPanel/SectionPanel";
import { OrderableList } from "components/Tables";
import React, { useEffect } from "react";
import { routes } from "utilities/routing/generatedRoutes";
import { FreeFieldRow } from "./FreeFieldRow";
import { DeleteDialog } from "components";

interface Props {
  freeFieldCategoryId: number
  mainArea: server.dto.MainAreas
  freeFieldDefinitions: server.dto.FreeFieldDefinitionSmall[]
}

export const FreeFieldsPanel = (props: Props) => {
  const [freeFields, setFreeFields] = React.useState<server.dto.FreeFieldDefinitionSmall[]>([]);
  const [deleteingFreeField, setDeletingFreeField] = React.useState<server.dto.FreeFieldDefinitionSmall | null>(null);

  useEffect(() => {
    setFreeFields(props.freeFieldDefinitions);
  }, [props.freeFieldDefinitions]);

  const onDelete = async () => {
    setFreeFields(freeFields.filter(f => f.freeFieldDefinitionId !== deleteingFreeField.freeFieldDefinitionId));
    await window.CoreApi.FreeFieldDefinition.Delete({ freeFieldDefinitionId: deleteingFreeField.freeFieldDefinitionId });
    setDeletingFreeField(null);
  }

  const onOrderChange = async (ffs: server.dto.FreeFieldDefinitionSmall[]) => {
    setFreeFields(ffs);
    await window.CoreApi.FreeFieldCategory.StoreSortedDefinitions({
      freeFieldCategoryId: props.freeFieldCategoryId,
      freeFieldDefinitionsIds: ffs.map(c => c.freeFieldDefinitionId)
    });
  }

  return <>
    <SectionPanel.Panel
      header={<>
        <PanelSegment.Title title={RESX.FreeField.FreeFields} />
        <PanelSegment.Button
          href={`${routes.freeFieldDefinition_New(props.mainArea).absolute}?catId=${props.freeFieldCategoryId}`}
          label={RESX.Buttons.btnNew}
          type="secondary"
        />
      </>}
    >
      <OrderableList
        items={freeFields}
        getKey={ff => ff.freeFieldDefinitionId.toString()}
        render={ff => <FreeFieldRow freeField={ff} />}
        onOrderChanged={onOrderChange}
        onDelete={(ff) => { setDeletingFreeField(ff); }}
      />
      {freeFields.length === 0 && <NoDataAvailableDiv />}
    </SectionPanel.Panel>
    <DeleteDialog
      isOpen={deleteingFreeField !== null}
      onDelete={onDelete}
      handleClose={() => { setDeletingFreeField(null); }}
      message={RESX.FreeField.DeleteFreeFieldConfirm}
    />
  </>
}